import React, { useEffect, useState } from "react";
import EditAlert from "./EditAlert";
import "./index.css";

const EditAlertAnimation = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`edit-alert-view ${animation ? "active" : ""}`}>
      <EditAlert />
    </div>
  );
};

export default EditAlertAnimation;
